import Article1 from '../pages/articles/Article1'
import Article2 from '../pages/articles/Article2'
import Article3 from '../pages/articles/Article3'
import Article4 from '../pages/articles/Article4'
import Article5 from '../pages/articles/Article5'
import Article1Image from '../assets/blog/article-1/1.webp'
import Article2Image from '../assets/blog/article-2/1.webp'
import Article3Image from '../assets/blog/article-3/1.webp'
import Article4Image from '../assets/blog/article-4/2.webp'
import Article5Image from '../assets/blog/article-5/2.webp'
// import Article5Image from '../assets/blog/article-5/1.webp'

const isAdmin = true
// eslint-disable-next-line no-undef
const URL = process.env.REACT_APP_URL_BACK
const URLApi = `${URL}api`

// Los nuevos van primero
const ARTICLES = [
  {
    title: 'VIDA en Experiencia Endeavor 2026: conexiones reales, comunidad en acción',
    image: Article5Image ,
    category: 'Evento',
    description: <>El pasado jueves 14 de mayo fuimos parte de la <strong>Experiencia Endeavor 2026</strong>, una jornada que reunió a emprendedores, empresarios y referentes con una misma intención: encontrarse, compartir ideas y construir comunidad...</>,
    link: '/blog/vida-en-experiencia-endeavor-2026',
    component: <Article5/>
  }, {
    title: 'HumanIA en VIDA Cowork: un encuentro para pensar el futuro con estrategia',
    image: Article4Image,
    category: 'Taller',
    description: <>El jueves pasado recibimos en nuestra sede Wast a <strong>HumanIA Comunidad</strong>, el proyecto creado por Nicolás Seleme y Melisa Campos...</>,
    link: '/blog/humanai-en-vida-cowork-un-encuentro-para-pensar-el-futuro-con-estrategia',
    component: <Article4/>
  }, {
    title: 'Renault eligió VIDA para fortalecer su equipo desde el bienestar',
    image: Article3Image,
    category: 'Evento',
    description: <>Recibimos en nuestras sedes al equipo de <strong>Calidad de Renault</strong>, que eligió VIDA Cowork para realizar una dinámica grupal de integración...</>,
    link: '/blog/renault-eligio-VIDA-para-fortalecer-su-equipo-desde-el-bienestar',
    component: <Article3/>
  }, {
    title: 'Dos encuentros, una misma esencia: vino, historias y comunidad en VIDA 🍷',
    image: Article2Image,
    category: 'Taller',
    description: <>Durante septiembre y octubre, en VIDA vivimos dos encuentros del <strong>Taller de Vinos junto a Fede Montiel</strong>...</>,
    link: '/blog/dos-encuentros-una-misma-esencia',
    component: <Article2/>
  }, {
    title: 'Soltar, crear, resignificar: Lo que nos dejó “Conectá con tu yo artista”',
    image: Article1Image,
    category: 'Taller',
    description: 'El jueves 24 de abril nos encontramos en Vida Cowork – Sede Wast para vivir un momento único...',
    link: '/blog/conecta-con-tu-yo-artista',
    component: <Article1/>
  }
]

export {
  isAdmin,
  URL,
  URLApi,
  ARTICLES
}
